export default "__VITE_ASSET__B$DGFkWx__"